export default "__VITE_ASSET__CXGTsnWC__"